(function() {
  if (window.freeShippingBarInitialized) return;
  window.freeShippingBarInitialized = true;
  
  const bar = document.querySelector('[data-free-shipping-bar]');
  if (!bar) return;
  
  const limit = parseInt(bar.dataset.limit, 10);
  const rate = window.Shopify && window.Shopify.currency ? window.Shopify.currency.rate || 1 : 1;
  const currencyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
  const useCurrencyCode = window.theme && window.theme.settings && window.theme.settings.currency_code_enable;
  
  let lastKnownTotal = null;
  
  function formatMoney(cents) {
    // Use themeCurrency if available, otherwise simple fallback
    if (typeof themeCurrency !== 'undefined' && themeCurrency.formatMoney) {
      let formatted = themeCurrency.formatMoney(cents, currencyFormat);
      if (useCurrencyCode && window.theme && window.theme.currencyCode) {
        formatted += ' ' + window.theme.currencyCode;
      }
      return formatted.replace('.00', '');
    }
    
    // Fallback: simple money formatting
    const dollars = (cents / 100).toFixed(2).replace('.00', '');
    return '$' + dollars;
  }
  
  // Unified update function that syncs ALL shipping bars on the page
  function updateAllBars(cartTotal) {
    const limitWithRate = limit * rate;
    const remaining = Math.max(0, limitWithRate - cartTotal);
    const percent = Math.min(100, (cartTotal / limitWithRate) * 100);
    const isQualified = cartTotal >= limitWithRate;
    const formattedRemaining = formatMoney(remaining);
    
    // Update ALL progress fills
    document.querySelectorAll('[data-progress-fill], [data-sticky-progress-fill]').forEach(function(fill) {
      fill.style.width = percent + '%';
    });
    
    // Update ALL markers
    document.querySelectorAll('[data-progress-marker], [data-sticky-progress-marker]').forEach(function(marker) {
      marker.style.left = percent + '%';
      marker.classList.toggle('is-hidden', isQualified);
    });
    
    // Update ALL trucks
    document.querySelectorAll('.free-shipping-bar__truck').forEach(function(truck) {
      truck.classList.toggle('free-shipping-bar__truck--active', isQualified);
    });
    
    // Update ALL remaining amount elements
    document.querySelectorAll('[data-remaining-amount], [data-sticky-remaining-amount]').forEach(function(el) {
      el.textContent = formattedRemaining;
    });
    
    // Update ALL default messages
    document.querySelectorAll('.free-shipping-bar__msg-default, [data-shipping-msg-default], [data-sticky-msg-default]').forEach(function(el) {
      el.classList.toggle('is-hidden', isQualified);
    });
    
    // Update ALL success messages
    document.querySelectorAll('.free-shipping-bar__msg-success, [data-shipping-msg-success], [data-sticky-msg-success]').forEach(function(el) {
      el.classList.toggle('is-hidden', !isQualified);
    });
  }
  
  // Expose globally for other components
  window.updateAllShippingBars = function(cartTotal) {
    updateAllBars(cartTotal);
  };
  
  function update(cartTotal) {
    updateAllBars(cartTotal);
  }
  
  function parsePriceFromText(text) {
    if (!text) return 0;
    const cleaned = text.replace(/[^0-9.,]/g, '').replace(',', '.');
    const price = parseFloat(cleaned);
    return isNaN(price) ? 0 : Math.round(price * 100);
  }
  
  function getCartTotalFromDOM() {
    const cartFinalEl = document.querySelector('[data-cart-final]');
    if (cartFinalEl) return parsePriceFromText(cartFinalEl.textContent);
    return 0;
  }
  
  function checkAndUpdate() {
    const currentTotal = getCartTotalFromDOM();
    if (currentTotal !== lastKnownTotal) {
      lastKnownTotal = currentTotal;
      update(currentTotal);
      // Dispatch event so other components (order summary, sticky bar) can update subtotals
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { total: currentTotal } }));
    }
  }
  
  setInterval(checkAndUpdate, 300);
  checkAndUpdate();
})();
